import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../public/images/animeboxd-user.png'


const _hoisted_1 = { class: "content pt-4 pb-10" }
const _hoisted_2 = { class: "content-wrap relative py-0 w-auto my-0 mx-auto px-4 lg:px-0 lg:w-950px text-left" }
const _hoisted_3 = { class: "profile-header mb-0 overflow-hidden block" }
const _hoisted_4 = { class: "profile-summary mb-12 relative" }
const _hoisted_5 = { class: "mobile-group flex items-end justify-center mb-3" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"profile-avatar self-start -mb-3 w-100px h-100px\"><span class=\"h-full w-full flex float-none mr-0 relative bg-clip-padding\"><span class=\"float-left pt-full\"></span><img src=\"" + _imports_0 + "\" class=\"h-full object-cover absolute w-full rounded-50% block overflow-hidden\" alt=\"thing \"><span class=\"rounded-50% border border-gray-text box-border h-full left-0 absolute top-0 whitespace-nowrap w-full\"></span></span></div>", 1)
const _hoisted_7 = { class: "profile-name pl-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "profile-name-wrap mb-0" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "whitespace-normal inline-block font-quicksand mr-1 max-w-450px overflow-hidden py-2 text-ellipsis align-middle text-2xl text-white font-bold" }, " mzymandias ")
], -1)
const _hoisted_9 = { class: "mal-profile-button visible overflow-hidden whitespace-nowrap w-full text-xs" }
const _hoisted_10 = { class: "profile-info mt-8" }
const _hoisted_11 = { class: "flex flex-wrap justify-center my-3 flex-start px-2" }
const _hoisted_12 = { class: "max-w-6em min-w-thing grow my-3 text-center pl-6" }
const _hoisted_13 = {
  href: "",
  class: "text-gray-button no-underline"
}
const _hoisted_14 = { class: "text-gray-off block text-xl" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-button block text-xs uppercase tracking-wide" }, "Watching", -1)
const _hoisted_16 = { class: "max-w-6em min-w-thing grow my-3 text-center pl-6 bg-profile-stat bg-stat-size bg-stat-position bg-repeat-y" }
const _hoisted_17 = {
  href: "",
  class: "text-gray-button no-underline"
}
const _hoisted_18 = { class: "text-gray-off block text-xl" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-button block text-xs uppercase tracking-wide" }, "Completed", -1)
const _hoisted_20 = { class: "max-w-6em min-w-thing grow my-3 text-center pl-6 bg-profile-stat bg-stat-size bg-stat-position bg-repeat-y" }
const _hoisted_21 = {
  href: "",
  class: "text-gray-button no-underline"
}
const _hoisted_22 = { class: "text-gray-off block text-xl" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-button block text-xs uppercase tracking-wide" }, "On Hold", -1)
const _hoisted_24 = { class: "max-w-6em min-w-thing grow my-3 text-center pl-6 xs:bg-profile-stat xs:bg-stat-size xs:bg-stat-position xs:bg-repeat-y" }
const _hoisted_25 = {
  href: "",
  class: "text-gray-button no-underline"
}
const _hoisted_26 = { class: "text-gray-off block text-xl" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-button block text-xs uppercase tracking-wide" }, "Dropped", -1)
const _hoisted_28 = { class: "max-w-6em min-w-thing grow my-3 text-center pl-6 bg-profile-stat bg-stat-size bg-stat-position bg-repeat-y" }
const _hoisted_29 = {
  href: "",
  class: "text-gray-button no-underline"
}
const _hoisted_30 = { class: "text-gray-off block text-xl" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-button block text-xs uppercase tracking-wide" }, "Planned", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: "text-center py-2 px-3 visible whitespace-nowrap uppercase bg-gray-button text-white border-none rounded shadow-profilePic tracking-wide font-bold",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewProfileOnMAL && _ctx.viewProfileOnMAL(...args)))
                  }, " View on MAL ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: '/list/' + _ctx.user.id + '/' + _ctx.user.username + '/watching'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h4", _hoisted_12, [
                      _createElementVNode("a", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.userDetails?.anime_statistics.num_items_watching), 1),
                        _hoisted_15
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_router_link, {
                  to: '/list/' + _ctx.user.id + '/' + _ctx.user.username + '/completed'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h4", _hoisted_16, [
                      _createElementVNode("a", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.userDetails?.anime_statistics.num_items_completed), 1),
                        _hoisted_19
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_router_link, {
                  to: '/list/' + _ctx.user.id + '/' + _ctx.user.username + '/on_hold'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h4", _hoisted_20, [
                      _createElementVNode("a", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.userDetails?.anime_statistics.num_items_on_hold), 1),
                        _hoisted_23
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_router_link, {
                  to: '/list/' + _ctx.user.id + '/' + _ctx.user.username + '/dropped'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h4", _hoisted_24, [
                      _createElementVNode("a", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.userDetails?.anime_statistics.num_items_dropped), 1),
                        _hoisted_27
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_router_link, {
                  to: '/list/' + _ctx.user.id + '/' + _ctx.user.username + '/plan_to_watch'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h4", _hoisted_28, [
                      _createElementVNode("a", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.userDetails?.anime_statistics.num_items_plan_to_watch), 1),
                        _hoisted_31
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}